import React, {useEffect, useState} from "react";
import {withStyles} from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import i18n from "../../../i18n";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Divider from "@material-ui/core/Divider";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import FormField from "../../Form/FormField";
import axios from "axios";
import _ from "lodash";
import ReactDOM from "react-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import {replaceVowels} from "../../Form/utils";
import FormSelect from "../../Form/FormSelect";

const formatString = (str) => {
    str = replaceVowels(str);
    return str.replace(/[^a-zA-Z0-9]/g, "_");
}

const progress = () => {
    let wrapper = document.createElement('div');
    ReactDOM.render(
        <CircularProgress size={50} thickness={5} style={{'color': '#db2129'}} />,
        wrapper
    );
    let content = wrapper.firstChild;

    return swal({
        content: content,
        text:i18n.get('building.site_journal.please_have_patience'),
        buttons:false,
        closeOnClickOutside: false,
        closeOnEsc: false,
    });
}

const sendData = async(values) => {
    let url = `project/export`;

    //progress();

    await axios.post(url, values ,{responseType: 'arraybuffer'})
        .then((res) => {
            if(res.status === 204){
                swal({
                    text:i18n.get('building.site_journal.select_period'),
                    icon:"warning",
                    dangerMode: true
                });
            }
            if(res.status === 200){
                const file = new Blob(
                    [res.data],
                    {type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = fileURL
                link.download = res.headers['custom-filename'];
                link.click();
                //swal.close();
                //window.open(fileURL);
            }
        }).catch(error => {
            console.error('error',error);
        });

    return false;
}


const RenderPdfDialog = (props) => {

    const {
        classes,
        open,
        handleClose,
        data,
    } = props;

    const timestamp = moment().format('YYYYMMDD');
    const title = i18n.get('project.pdf.deficiencies_list');
    const fileName = timestamp + '_' + formatString(title).toLowerCase();

    const defaultValues = {
        title: title,
        searchString: title,
        fileName: fileName,
        building: null,
        subcontractor: null,
        orderBy: 'created_at',
        sort:'desc',
        projects: _.map(data.projects,'id')
    };

    const constructionProjects =  data.projects && _.map(data.projects,'project_building.building.parent');
    const buildings = constructionProjects && _.orderBy( _.uniqBy( constructionProjects,'id' ),'name' );

    const projectContacts = data.projects && _.map(data.projects,'contacts');
    const contacts = projectContacts && _.map( projectContacts, '0.contact' );
    const subcontractors = _.orderBy( _.uniqBy( contacts, 'id'), 'company_name');

    const [values,setValues] = useState(defaultValues);

    const setFieldValue = (field,value) => {
        values[field] = value;
        setValues({...values});
    }

    const closeDialog = () => {
        setValues(defaultValues);
        handleClose();
    }

    const handleSubmit = () => {
        sendData( values ).then(res => {
            if(res) {
                closeDialog();
            }
        })
    }
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={closeDialog}
                disableBackdropClick={true}
                className={classes.dialog}
                fullWidth={true}
                maxWidth={'sm'}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title" className={classes.dialogTitle}  disableTypography>
                    <Typography variant="h6" color={"primary"}>{i18n.get('project.pdf.export_search_results')}</Typography>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={closeDialog}>
                        <Icon>close</Icon>
                    </IconButton>
                    <div style={{fontSize:11,color:'#999999'}}>
                        Hinweis:
                        <div>{i18n.get('project.pdf.hint')}</div>
                    </div>

                </DialogTitle>
                <Divider/>
                <DialogContent className={classes.dialogContent}>
                    <FormField
                        type="text"
                        name="title"
                        label={'Überschrift des PDF-Dokumentes'}
                        onChange={(e) => {
                            setFieldValue('title',e.target.value);
                        }}
                        value={values.title}
                        InputLabelProps={{shrink: true}}
                    />

                    <FormField
                        type="text"
                        name="fileName"
                        label={i18n.get('project.pdf.file_name') + ' - ' + i18n.get('project.pdf.file_name_hint')}
                        onChange={(e) => {
                            setFieldValue('fileName',e.target.value);
                        }}
                        value={values.fileName}
                        InputLabelProps={{shrink: true}}
                    />

                    <FormSelect
                        type="text"
                        name="building"
                        label={i18n.get('project.deficiency.construction_project')}
                        onChange={(option)=>{
                            setFieldValue('building',option ? option.value : null);
                            let deficiencies = _.filter(data.projects,deficiency => {
                                return option
                                    ? deficiency.project_building.building.parent.id === option.value
                                    : false;
                            })
                            setFieldValue('projects', deficiencies.length
                                ? _.map(deficiencies,'id')
                                : _.map(data.projects,'id')
                            );
                        }}
                        options={
                            buildings
                                ? buildings.map( building => ({label:building.name, value:building.id}) )
                                : ['']
                        }
                        value={values.building}
                        isClearable={true}
                        autoComplete={"off"}
                    />
                    {/*<FormSelect*/}
                    {/*    type="text"*/}
                    {/*    name="subcontractor"*/}
                    {/*    label={i18n.get('project.deficiency.subcontractor')}*/}
                    {/*    onChange={(option)=>{*/}
                    {/*        // setFieldValue('building',option ? option.value : null);*/}
                    {/*        // let deficiencies = _.filter(data.projects,deficiency => {*/}
                    {/*        //     return deficiency.project_building.building.parent.id === option.value;*/}
                    {/*        // })*/}
                    {/*        // deficiencies*/}
                    {/*    }}*/}
                    {/*    // options={*/}
                    {/*    //     // subcontractor*/}
                    {/*    //     //     ? buildings.map(building => ({label:building.name, value:building.id}))*/}
                    {/*    //     //     : ['']*/}
                    {/*    // }*/}
                    {/*    value={values.subcontractor}*/}
                    {/*    isClearable={true}*/}
                    {/*    autoComplete={"off"}*/}
                    {/*/>*/}
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    {/*<Button*/}
                    {/*    component={'a'}*/}
                    {/*    variant={'contained'}*/}
                    {/*    color={'primary'}*/}
                    {/*    size={'small'}*/}
                    {/*    name={'preview'}*/}
                    {/*    onClick={() => handleSubmit(true)}*/}
                    {/*>*/}
                    {/*    {i18n.get('project.pdf.preview')}*/}
                    {/*</Button>*/}
                    <Button
                        component={'a'}
                        variant={'contained'}
                        color={'primary'}
                        size={'small'}
                        style={{marginLeft:10}}
                        name={'download'}
                        onClick={()=> handleSubmit(false)}
                    >
                        {i18n.get('project.pdf.download')}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

const styles = theme => ({
dialog: {
minHeight:700,
},
dialogTitle: {
color: theme.colors.primary,
},
dialogContent: {
overflow:'visible',
},
dialogActions: {
paddingRight: theme.spacing.unit * 2,
paddingBottom: theme.spacing.unit * 2,
},
closeButton: {
position: 'absolute',
right: theme.spacing.unit * 1.2,
top: theme.spacing.unit * 2,
},
});

export default (withStyles(styles)) (RenderPdfDialog)
